// src/components/doctor/OpenItemsList.jsx
//
// The Open items slide-over on the doctor's patient record. Urgent items
// ("Needs action now") come first, then routine ones; the triage pipeline's raw
// "[AUTO] triage:… | …" text is replaced by the clinical sentence
// (utils/actionItems.js), everywhere — including the checkbox's accessible name.

import React from 'react';
import { groupOpenItems } from '../../utils/actionItems';

const fmtDue = d => new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

function Group({ title, rows, onToggle }) {
  if (rows.length === 0) return null;
  return (
    <section aria-label={title}>
      <div className="field-label prec-items__h">{title} · {rows.length}</div>
      <div className="card-list">
        {rows.map(({ item, text, label }) => (
          <label key={item.id} className="card-row prec-items__row">
            <input type="checkbox" checked={false} onChange={() => onToggle(item.id, true)}
              aria-label={`Mark done: ${text}`} />
            <div className="card-row-body">
              <div className="card-row-title">{text}</div>
              <div className="card-row-meta">
                {label}{item.dueDate ? ` · due ${fmtDue(item.dueDate)}` : ''}
              </div>
            </div>
          </label>
        ))}
      </div>
    </section>
  );
}

export default function OpenItemsList({ items, onToggle }) {
  const { now, routine } = groupOpenItems(items);
  if (now.length + routine.length === 0) return <div className="field-text">Nothing outstanding.</div>;
  return (
    <div className="prec-items">
      <Group title="Needs action now" rows={now} onToggle={onToggle} />
      <Group title="Routine" rows={routine} onToggle={onToggle} />
    </div>
  );
}
